<template>
  <!-- <template v-for="(coupon, index) in availables_coupons" :key="index"> -->
  <Card
    card_class="backdrop-blur-lg flex-grow"
    card_body_class="flex rounded-md overflow-hidden"
  >
    <div
      class="w-32 px-2 py-1 -ml-3 -my-2 rounded-l-md bg-white/60 text-black flex flex-col justify-center"
    >
      <h3 class="text-lg font-semibold">
        {{
          coupon_on_percentage
            ? coupon_discount + "%"
            : formatRupiah(coupon_discount)
        }}
      </h3>
      <hr class="border-black" />
      <small
        class="whitespace-nowrap tracking-tight text-center uppercase text-xs flex flex-col"
        ><span>Valid Thru</span
        ><span>{{
          formatDate(subtractOneDay(coupon_expired_date))
        }}</span></small
      >
    </div>
    <div class="px-3 flex flex-col justify-center flex-grow">
      <h3 class="text-lg font-semibold leading-tight line-clamp-3">
        {{ coupon_product_name }}
      </h3>
      <div class="flex mt-2 space-x-3">
        <p class="text-xs whitespace-nowrap">
          Max Usage:
          <span class="uppercase text-white/70">{{ coupon_max_usage }}</span>
        </p>
        <p v-if="coupon_usage_count" class="text-xs whitespace-nowrap">
          Usage Count:
          <span class="uppercase text-white/70">{{ coupon_usage_count }}</span>
        </p>
      </div>
    </div>
    <div v-if="is_expired" class="flex justify-end items-center">
      <img
        src="/images/icons/expired.webp"
        class="w-[65px] h-[65px]"
        alt="expired coupon"
      />
    </div>
  </Card>
</template>

<script>
import { formatRupiah, formatDate } from "@/helpers/formating";
import Card from "@/components/organisms/Card.vue";

export default {
  name: "Coupon",
  props: {
    coupon_discount: [String, Number],
    coupon_expired_date: [String],
    coupon_product_name: [String],
    coupon_max_usage: [String, Number],
    coupon_usage_count: [Number],
    is_expired: [Boolean],
    coupon_on_percentage: [Boolean],
  },

  methods: {
    formatDate,
    formatRupiah,
    subtractOneDay(date) {
      const dateObj = new Date(date);
      dateObj.setDate(dateObj.getDate() - 1);
      return dateObj;
    },
  },
  components: {
    Card,
  },
};
</script>

<style scoped></style>
